import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import PendingApproval from "../pages/PendingApproval";

export function ProtectedRoute({ children, adminOnly = false }) {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
        <div className="text-sm" style={{ color: "var(--text-mute)" }}>Munkamenet ellenőrzése...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/catalog" replace />;
  // Non-admin customer who hasn't been approved yet → show pending screen, not the catalog
  if (user.role !== "admin" && user.approved === false) return <PendingApproval />;
  return children;
}
